// Toast mutations
const ADD_TOAST = 'toasts/ADD_TOAST';
const REMOVE_TOAST = 'toasts/REMOVE_TOAST';

let toastID = 0;

// initial state
const state = {
  items: []
};

// mutations
const mutations = {
  [ADD_TOAST] (state, toast) {
    state.items.push(toast);
  },

  [REMOVE_TOAST] (state, id) {
    state.items = state.items.filter(m => m.id !== id);
  }
};

const actions = {
  addToast: ({ commit, dispatch }, { type = 'info', duration = 4000, text, action = null }) => {
    const id = toastID++;
    commit(ADD_TOAST, { id, type, text, action });
    setTimeout(() => {
      dispatch('removeToast', id);
    }, duration);
  },

  removeToast: ({ commit }, id) => {
    commit(REMOVE_TOAST, id);
  },
};

const getters = {
  toasts (state) {
    return state.items;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/plugins/toasts/module.js